/**
 * Ce que le téléphone doit oublier quand le compte connecté change. Un téléphone se prête : la personne
 * suivante ne doit rien retrouver de la précédente (messages, demandes de contact, notifications).
 * - `everything` : lectures en cache, images, et actions en attente d'envoi ;
 * - `reads` : lectures et images seulement. Les actions en attente sont gardées : une session qui expire
 *   au bord du terrain ne doit pas faire perdre une feuille de match saisie sans réseau ;
 * - `nothing` : même compte, rien à faire.
 */
export type ForgetLevel = "nothing" | "reads" | "everything";

export function whatToForget(
  lastUid: string | null,
  newUid: string | null,
  explicitSignOut: boolean,
): ForgetLevel {
  if (explicitSignOut) return "everything";
  if (newUid) return lastUid && lastUid !== newUid ? "everything" : "nothing";
  return lastUid ? "reads" : "nothing";
}
